import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { parseCookies, setCookie } from 'nookies'

export default function ModalCookies() {
    const [showCookiesContainer, setShowCookiesContainer] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [tabSelected, setTabSelected] = useState('preferencia');

    useEffect(() => {
        function validCookie() {
            let cookies = parseCookies();

            if (cookies['cookie-accepted']) {
                setShowCookiesContainer(false);   
            } else {
                setShowCookiesContainer(true);   
            }
        }

        validCookie();
    }, []);

    function accept() {
        setCookie(null, 'cookie-accepted', 'true', {
            maxAge: 60 * 60,
            path: '/'
          });

        setShowModal(false);
        setShowCookiesContainer(false);
    }

    function handleModalCookies() {
        setShowModal(!showModal);
    }

    return (
        <>
            <div className={`cookies-container ${!showCookiesContainer ? 'hide-cookies-container' : ''}`}>
                <div className='info-container'>
                    <p>
                        Utilizamos cookies para melhorar a experiência do usuário e analisar o tráfego do site. Por esses motivos, 
                        podemos compartilhar os dados de uso do seu site com nossos parceiros de análise. Ao clicar em &quot;Aceitar cookies&quot;, 
                        você concorda em armazenar em seu dispositivo todas as tecnologias descritas em nossa <a href="https://epharma.com.br/politica-de-cookies/" target='_blank' rel="noopener">Política de cookies</a>. 
                        Para mais informações consulte também nossa <a href='https://epharma.com.br/politica-de-privacidade/' target='_blank' rel="noopener">Política de Privacidade</a>. 
                        Você pode alterar suas configurações de cookies a qualquer momento clicando em “Preferências de Cookies”.
                    </p>
                    <div className="buttons-container">
                        <button onClick={handleModalCookies}>
                            Preferências de Cookies
                        </button>
                        <button onClick={accept}>
                            Aceitar
                        </button>
                    </div>
                </div>
            </div>
            <button className='cookie-button' onClick={() => setShowCookiesContainer(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" fill='#FFF' viewBox="0 0 256 256"><path d="M164.49 163.51a12 12 0 1 1-17 0 12 12 0 0 1 17 0Zm-81-8a12 12 0 1 0 17 0 12 12 0 0 0-16.98 0Zm9-39a12 12 0 1 0-17 0 12 12 0 0 0 17-.02Zm48-1a12 12 0 1 0 0 17 12 12 0 0 0 0-17ZM232 128A104 104 0 1 1 128 24a8 8 0 0 1 8 8 40 40 0 0 0 40 40 8 8 0 0 1 8 8 40 40 0 0 0 40 40 8 8 0 0 1 8 8Zm-16.31 7.39A56.13 56.13 0 0 1 168.5 87.5a56.13 56.13 0 0 1-47.89-47.19 88 88 0 1 0 95.08 95.08Z"></path></svg>
            </button>
            <div className="cookies-modal">
            </div>
            <Modal show={showModal} onHide={handleModalCookies} size='lg'>
                <Modal.Body>
                    <div className="modal-cookies-container">
                        <h2>
                            Sua privacidade
                        </h2>
                        <div className="tab-container">
                            <div className={`tabItem`} onClick={() => setTabSelected('preferencia')}>
                                <span className={`${tabSelected === 'preferencia' ? 'selected' : ''}`}>Preferências de cookies</span>
                            </div>
                            <div className={`tabItem`} onClick={() => setTabSelected('politica')}>
                                <span className={`${tabSelected !== 'preferencia' ? 'selected' : ''}`}>Política de cookies</span>
                            </div>
                        </div>
                        <div className="modal-cookie-info">
                            {tabSelected === 'preferencia' && (
                                <div className='container-preferencia'>
                                    <p>
                                        Utilizamos cookies para melhorar a experiência do usuário e analisar o tráfego do 
                                        site. Por esses motivos, podemos compartilhar os dados de uso do seu site com 
                                        nossos parceiros de análise. Ao clicar em &quot;Aceitar cookies&quot;, você concorda em armazenar 
                                        em seu dispositivo todas as tecnologias descritas em nossa <a href="https://epharma.com.br/politica-de-cookies/" target='_blank' rel="noopener">Política de cookies</a>. Para mais informações 
                                        consulte também nossa <a href='https://epharma.com.br/politica-de-privacidade/' target='_blank' rel="noopener">Política de Privacidade </a>. Você pode alterar suas configurações de cookies a 
                                        qualquer momento clicando em “Preferências de Cookies”.
                                    </p>

                                    <h3>Funcionalidades</h3>

                                    <p>
                                        Cookies de funcionalidade são essenciais para garantir o funcionamento correto do 
                                        nosso site. Eles permitem que você se lembre de escolhas anteriores, como 
                                        configurações de layout e preferências, para uma experiência de navegação mais 
                                        conveniente e personalizada. Sem esses cookies, algumas funcionalidades do site 
                                        podem não estar disponíveis.
                                    </p>
                                </div>
                            )}
                            {tabSelected === 'politica' && (
                                <div className='container-preferencia'>
                                    <div className="politica-item">
                                        <h3>Política de cookies</h3>
                                        <p>
                                            Esta Política de Cookies explica como o(a) epharma.com.br usa cookies e tecnologias semelhantes para reconhecê-lo quando você visita nossos sites em https://epharma.com.br, (&quot;Sites&quot;). Ele explica o que são essas tecnologias e por que as usamos, bem como seus direitos de controlar nosso uso delas. Em alguns casos, podemos usar cookies para coletar informações pessoais ou que se tornam informações pessoais se as combinarmos com outras informações.
                                        </p>
                                    </div>

                                    <div className="politica-item">
                                        <h3>
                                            O que são cookies?
                                        </h3>
                                        <p>
                                            Cookies são pequenos arquivos de dados que são colocados no seu computador ou dispositivo móvel quando você visita um site. Os cookies são amplamente utilizados pelos proprietários de sites para fazer com que seus sites funcionem, ou para trabalhar com mais eficiência, além de fornecer informações de relatórios. Os cookies definidos pelo proprietário do site (neste caso, epharma.com.br) são chamados de &quot;cookies primários&quot;. Os cookies definidos por terceiros que não o proprietário do site são chamados de &quot;cookies de terceiros&quot;. Os cookies de terceiros permitem que recursos ou funcionalidades de terceiros sejam fornecidos no ou através do site (por exemplo, publicidade, conteúdo interativo e análise). As partes que configuram esses cookies de terceiros podem reconhecer seu computador quando ele visita o site em questão e também quando visita outros sites.
                                        </p>
                                    </div>

                                    <div className="politica-item">
                                        <h3>Por que usamos cookies?</h3>
                                        <p>
                                            Utilizamos cookies de primeira e de terceiros por vários motivos. Alguns cookies são necessários por razões técnicas para que nossos sites funcionem, e nós os referimos como cookies &quot;essenciais&quot; ou &quot;estritamente necessários&quot;. Outros cookies também nos permitem rastrear e direcionar os interesses de nossos usuários para aprimorar a experiência em nossas Propriedades Online. Terceiros servem cookies nos nossos sites para publicidade, análises e outros fins. Isso é descrito em mais detalhes abaixo.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: 0 }}>
                    <Button onClick={accept}>Aceitar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}